import Vue from 'vue'
import VueRouter from 'vue-router'
import {constantRoutes, asyncRoutes} from './instance';
Vue.use(VueRouter)
/**
 * history 跳转历史记录给type传参，定位指定模块列表
 * @type {VueRouter}
 */

const createRouter = () =>
  new VueRouter({
    base: process.env.PATH_ENV === 'dev' ? '' : '/hotelonething/',
    mode: 'history',
    routes: constantRoutes
  });
const router = new createRouter()
// 重置路由
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

// 导出静态和动态路由
export {
  constantRoutes,
  asyncRoutes
}

export default router;

/**
 * 重写路由的push方法
 * 解决，相同路由跳转时，报错
 * 添加，相同路由跳转时，触发watch (针对el-menu，仅限string方式传参，形如"view?id=5")
 */
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  sessionStorage.setItem('k_route_opt', JSON.stringify({type: "push"}));
  return routerPush.call(this, location).catch(error=> error)
}

//重写路由的replace方法
const routerReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  sessionStorage.setItem('k_route_opt', JSON.stringify({type: "replace"}));
  return routerReplace.call(this, location).catch(error=> error)
}

//重写路由的go方法
const routerGo = VueRouter.prototype.go;
VueRouter.prototype.go = function go(location) {
  sessionStorage.setItem("k_route_opt", JSON.stringify({type: "go", number: location}));
  return routerGo.call(this, location);
};



// WEBPACK FOOTER //
// ./src/router/index.js